<template>
  <v-container grid-list-md>
    <v-layout row wrap>
      <v-flex xs8 offset-xs2>
        <p
          class="text-xs-center subheading"
          v-html="$t('message.instructions.owners')"
        ></p>
      </v-flex>
      <v-layout row wrap class="btn-wrapper">
        <v-dialog
          v-model="dialog"
          @keydown.esc="dialog = false"
          persistent
          max-width="600px"
        >
          <v-btn
            v-show="this.$store.getters.getOwners.length != 0"
            slot="activator"
            class="btn-primary"
          >
            <img src="static/icons/add_white.png" width="24" />
            add
            {{ $t('message.ownerLabel') }}
          </v-btn>
          <v-form
            ref="ownerForm"
            v-model="valid"
            @keydown="errors.clear($event.target.name)"
          >
            <v-card>
              <v-card-title>
                <span v-if="ownerIndex == -1" class="headline">{{
                  $t('message.newOwner')
                }}</span>
                <span v-else class="headline">{{
                  $t('message.updateOwner')
                }}</span>
              </v-card-title>
              <v-card-text>
                <v-container grid-list-md class="no-top-padding">
                  <v-layout row wrap>
                    <v-flex xs12 sm6>
                      <v-text-field
                        v-model.trim="owner.name"
                        :label="$t('message.owner.name')"
                        maxlength="30"
                        :counter="30"
                        v-validate="'required'"
                        :error-messages="errors.collect('name')"
                        name="name"
                        data-vv-as=" "
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6>
                      <v-text-field
                        v-model="owner.emailAddress"
                        :label="$t('message.email')"
                        maxlength="60"
                        :counter="60"
                        :disabled="!allowEmailUpdate()"
                        v-validate="'required|email'"
                        :error-messages="errors.collect('emailAddress')"
                        name="emailAddress"
                        data-vv-as=" "
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6>
                      <v-text-field
                        v-model="owner.percentageOwned"
                        :label="$t('message.owner.percentageOwned')"
                        :mask="numberMask3"
                        v-validate="'required|min_value:25|max_value:100'"
                        :error-messages="errors.collect('percentageOwned')"
                        name="percentageOwned"
                        data-vv-as=" "
                        validate-on-blur
                        type="tel"
                        min="1"
                        max="100"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6>
                      <v-text-field
                        v-model="owner.title"
                        :label="$t('message.owner.title')"
                        maxlength="20"
                        :counter="20"
                        v-validate="'required'"
                        :error-messages="errors.collect('title')"
                        name="title"
                        data-vv-as=" "
                        validate-on-blur
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6>
                      <v-text-field
                        v-model="owner.ssn"
                        :label="$t('message.owner.ssn')"
                        :type="hideSsn ? 'password' : 'text'"
                        @click:append="hideSsn = !hideSsn"
                        :append-icon="'visibility'"
                        v-on:blur="hideSsn = true"
                        v-validate="ssnRules"
                        :error-messages="errors.collect('ssn')"
                        name="ssn"
                        data-vv-as=" "
                        :mask="ssnMask"
                        validate-on-blur
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6>
                      <v-text-field
                        v-model="owner.dateOfBirth"
                        :label="$t('message.owner.dateOfBirth')"
                        v-validate="dateOfBirthRules"
                        :error-messages="errors.collect('dateOfBirth')"
                        name="dateOfBirth"
                        data-vv-as=" "
                        :mask="dateOfBirthMask"
                        validate-on-blur
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6>
                      <v-text-field
                        v-model="owner.phoneNumber"
                        :label="$t('message.phoneNumber')"
                        type="tel"
                        v-validate="phoneNumberRules"
                        :error-messages="errors.collect('phoneNumber')"
                        name="phoneNumber"
                        data-vv-as=" "
                        :mask="phoneMask"
                        validate-on-blur
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        v-model="owner.addressStreet"
                        :label="$t('message.homeAddress')"
                        v-validate="'required'"
                        :error-messages="errors.collect('streetAddress')"
                        name="streetAddress"
                        data-vv-as=" "
                        validate-on-blur
                        maxlength="30"
                        :counter="30"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  
                  <v-layout row wrap>
                    <v-flex xs12 sm6>
                      <v-text-field
                        v-model="owner.addressCity"
                        :label="$t('message.city')"
                        validate-on-blur
                        v-validate="'required'"
                        :error-messages="errors.collect('addressCity')"
                        name="addressCity"
                        data-vv-as=" "
                        maxlength="20"
                        :counter="20"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs6 sm3>
                      <v-text-field
                        v-model="owner.addressState"
                        :mask="stateMask"
                        :label="$t('message.state')"
                        v-validate="addressStateRules"
                        :error-messages="errors.collect('addressState')"
                        name="addressState"
                        data-vv-as=" "
                        validate-on-blur
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs6 sm3>
                      <v-text-field
                        v-model="owner.addressZipCode"
                        :mask="zipMask"
                        :label="$t('message.zipCode')"
                        type="tel"
                        v-validate="zipCodeRules2"
                        :error-messages="errors.collect('zipCode')"
                        name="zipCode"
                        data-vv-as=" "
                        validate-on-blur
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn flat class="btn-secondary" @click.native="close">{{
                  $t('message.cancel')
                }}</v-btn>
                <v-btn
                  flat
                  class="btn-primary"
                  v-show="this.ownerIndex == -1"
                  @click="saveOwner"
                  :disabled="errors.any() || saveDisabled"
                  >{{ $t('message.add') }}</v-btn
                >

                <v-tooltip top>
                  <v-btn
                    flat
                    slot="activator"
                    class="btn-primary mx-1"
                    v-show="this.ownerIndex != -1"
                    @click="saveOwner"
                    :disabled="errors.any() || saveDisabled"
                    >{{ $t('message.save') }}</v-btn
                  >
                  <span>{{ $t('message.saveAndResume') }}</span>
                </v-tooltip>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>
      </v-layout>
      <v-container grid-list-md v-if="this.$store.getters.getOwners.length > 0">
        <v-data-table
          :headers="headers"
          :items="this.$store.getters.getOwners"
          hide-actions
          class="elevation-1"
        >
          <template slot="items" slot-scope="props">
            <td class="hidden-sm-and-down">{{ props.item.name }}</td>
            <td>{{ props.item.emailAddress }}</td>
            <td>{{ props.item.percentageOwned }}</td>
            <td class="text-xs-right" nowrap>
              <v-tooltip bottom>
                <v-btn
                  slot="activator"
                  icon
                  class="px-0 mx-0"
                  @click="edit(props.item)"
                >
                  <img src="static/icons/create_gray.png" width="26" />
                </v-btn>
                <span>{{ $t('message.edit') }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <v-btn
                  slot="activator"
                  @click="remove(props.item)"
                  icon
                  class="px-0 mx-0"
                >
                  <img src="static/icons/delete_gray.png" width="26" />
                </v-btn>
                <span>{{ $t('message.remove') }}</span>
              </v-tooltip>
            </td>
          </template>
        </v-data-table>
      </v-container>
      <empty-list
        v-if="this.$store.getters.getOwners.length == 0"
        v-bind:message="$t('message.ownerLabel')"
        @clicked="dialog = true"
      ></empty-list>
    </v-layout>
  </v-container>
</template>

<script>
import { axiosAuthInstance } from '../../main.js'
import EmptyList from '../util/EmptyList'

export default {
  data() {
    return {
      headers: [
        {
          text: 'Full Name',
          align: 'left',
          value: 'name',
          class: 'hidden-sm-and-down',
          sortable: false
        },
        { text: 'Email Address', value: 'emailAddress', sortable: false },
        { text: 'Percentage Owned', value: 'percentageOwned', sortable: false },
        { value: '', sortable: false }
      ],
      owner: {
        id : -1
      },
      ssnMask: '###-##-####',
      dateOfBirthMask: '##/##/####',
      showOwnerForm: false,
      saveDisabled: false,
      dialog: false,
      loading1: {},
      loading2: {},
      hideSsn: true,
      valid: false,
      ownerIndex: -1
    }
  },
  computed: {
    zipCodeRules2() {
      return 'required|length:5'
    },
    dateOfBirthRules() {
      return 'required|date_format:MMddyyyy'
    },
    ssnRules() {
      return 'required|valid_ssn'
    },
    phoneNumberRules() {
      return 'required|length:10'
    },
    addressStateRules() {
      return 'required|valid_us_state'
    }
  },

  methods: {
    allowEmailUpdate: function() {
      return (
        this.ownerIndex == -1 || this.owner.status == 'NEW'
      )
    },
    saveOwner() {
      if (this.checkAndConfirmInvalidate()) {
        this.$validator.validateAll().then(result => {
          if (result) {
            //check if duplicate owner && ownership percentage is <= 100%
            var totalOwnership = parseInt(this.owner.percentageOwned)
            for (var existingOwner of this.$store.getters.getOwners) {
              if (existingOwner.id != this.owner.id && existingOwner.emailAddress.toLowerCase() == this.owner.emailAddress.toLowerCase()) {
                this.notifyWarn('The given email has already been added as an owner. Owner emails must be unique.')
                return
              }

              if (this.owner.id != -1 && existingOwner.id != this.owner.id) {
                totalOwnership += parseInt(existingOwner.percentageOwned)
              }
            }

            if (totalOwnership > 100) {
              this.notifyWarn('The total of all ownership is greater than 100%.')
              return
            }

            this.saveDisabled = true
            let tempOwner = Object.assign({}, this.owner);
            tempOwner.applicationId = this.$store.getters.getApplicationId
            let serviceMethod = 'update'
            if (this.ownerIndex == -1) {
              this.owner.id = -1
              tempOwner.status = 'NEW'
              serviceMethod = 'create'
            }

            //wipe out last update date since server maintains that
            delete tempOwner.lastUpdateDate

            axiosAuthInstance
              .post('api/v1/owner/' + serviceMethod, tempOwner)
              .then(response => {
                if (this.ownerIndex > -1) {
                  this.$store.getters.getOwners[this.ownerIndex] =
                    Object.assign(this.$store.getters.getOwners[this.ownerIndex], tempOwner)
                } else {
                  tempOwner = response.data
                  this.$store.getters.getOwners.push(tempOwner)
                }
                this.checkOwnersComplete()
                this.close()

                if (this.ownerIndex > -1) {
                  this.notifyInfo('Successfully updated owner.')
                } else {
                  this.notifyInfo('Successfully added owner.')
                }
              })
              .catch(error => {
                this.notifyAxiosError(
                  error,
                  'There was an error ' +
                  serviceMethod.slice(0, -1) +
                  'ing the owner'
                )
              })
              .then(() => {
                if (this.$store.getters.isApplicationJustInvalidated) {
                  this.$store.commit('setApplicationJustInvalidated', false)
                  this.$router.go() //reload to pick up all server side changes
                }
                this.saveDisabled = false
              })
          }
        })
      }
    },
    close() {
      this.dialog = false
      setTimeout(() => {
        this.$refs.ownerForm.reset()
        this.ownerIndex = -1
        this.owner = {}
        this.saveDisabled = false
      }, 200)
    },
    edit(inOwner) {
      this.ownerIndex = this.$store.getters.getOwners.indexOf(inOwner)
      this.owner = Object.assign({}, inOwner)
      this.saveDisabled = false
      this.$validator.errors.clear() //otherwise errors show when dialog is opened
      this.dialog = true
    },
    remove(inOwner) {
      if (confirm('Are you sure you want to remove this owner?')) {
        axiosAuthInstance
          .delete('api/v1/owner/', { data: inOwner })
          .then(response => {
            const index = this.$store.getters.getOwners.indexOf(inOwner)
            this.$store.getters.getOwners.splice(index, 1)
            this.checkOwnersComplete()
          })
          .catch(error => {
            this.notifyAxiosError(
              error,
              'There was an error deleting ' + inOwner.emailAddress
            )
          })
      }
    },
    checkOwnersComplete() {
      var owners = this.$store.getters.getOwners
      var ok = false
      for (var i = 0; i < owners.length; i++) {
        if (owners[i].percentageOwned >= 25) {
          ok = true
          break
        }
      }

      this.$store.commit('setOwnerComplete', ok)

      return ok
    }
  },
  mounted() {
    axiosAuthInstance
      .get('api/v1/owner/application/' + this.$store.getters.getApplicationId)
      .then(response => {
        if (response.data && response.data.length > 0) {
          this.$store.commit('setOwners', response.data)
        }
      })
      .catch(error => {
        this.notifyAxiosError(
          error,
          'There was an error retrieving the owners '
        )
      })
      .then(() => {
        this.checkOwnersComplete()
      })
  },
  components: {
    'empty-list': EmptyList
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Application/Owners.vue